import { Directive, HostListener, ElementRef, Optional, Input } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';


@Directive({
    selector: '[controlTrim]'
})
export class TrimDirective {

    @Input() upperCase: boolean = false;

    constructor(private el: ElementRef,  @Optional() private ngControl: NgControl) { }

    @HostListener('blur') onBlur() {
        // console.log("BLUR", this.el, this.ngControl, this.ngControl.control, this.ngControl.control.value);
        let ctrl: AbstractControl = this.ngControl.control;
        if(ctrl.value != null) {
            let s: string = ctrl.value.toString().trim();
            ctrl.setValue((this.upperCase == true) ? s.toUpperCase(): s);
        }
            
    }

}